import classNames from "classnames";
import React from "react";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import {
  AppCard,
  AppCardContent,
  AppCardHeader,
  AppCardSubtitle,
  AppCardTitle,
} from "./Generic/AppCard";
import { If } from "./Generic/If";
import { IsDefined } from "./Generic/IsDefined";
import { RequiredDocAnswerableQuestionProps } from "./RequiredDocAnswerableQuestion";
import RequiredDocReadonlyAnswer from "./RequiredDocReadonlyAnswer";

type Props = RequiredDocAnswerableQuestionProps;

const RequiredDocTime = (props: Props) => {
  return (
    <AppCard
      className={classNames({ __invalid: !props.isValid })}
      onClick={() => {
        if (props.readonly && props.onClickWhileDisabled !== undefined) {
          props.onClickWhileDisabled();
        }
      }}
    >
      <AppCardHeader>
        <AppCardTitle>
          {props.questionText}
          <If condition={props.isRequired}>
            <span className="__badge">{translate(STRINGS.REQUIRED)}</span>
          </If>
        </AppCardTitle>
        <IsDefined value={props.notes}>
          {(notes) => <AppCardSubtitle>{`${translate(STRINGS.NOTES)}: ${notes}`}</AppCardSubtitle>}
        </IsDefined>
      </AppCardHeader>
      <AppCardContent>
        {props.readonly ? (
          <RequiredDocReadonlyAnswer currentAnswer={props.currentAnswer} />
        ) : (
          <input
            type="time"
            disabled={props.readonly}
            className="ScheduledVisitDocScreen__margin ScheduledVisitDocScreen__block text-input text-input--material"
            onChange={(e) => props.handleOnInsertAnswer(props.questionId, e.target.value)}
            value={props.currentAnswer === null ? "" : props.currentAnswer}
          />
        )}
      </AppCardContent>
    </AppCard>
  );
};

export default React.memo(RequiredDocTime);
